import {Routes} from '@angular/router';
import {PeopleMainTabsComponent} from './people-main-tabs/people-main-tabs.component';
import {PeopleUsersWrapperComponent} from './people-users-wrapper/people-users-wrapper.component';
import {PeopleTeamsWrapperComponent} from './people-teams-wrapper/people-teams-wrapper.component';
import {PeopleRolesWrapperComponent} from './people-roles-wrapper/people-roles-wrapper.component';
import {PeopleLensesWrapperComponent} from './people-lenses-wrapper/people-lenses-wrapper.component';
import {UserDetailComponent} from '../users/detail/user-detail.component';
import {RolePermissionsGuard} from '../core/guards/role-permissions.guard';
// import {adminGuard} from '../core/guards/admin.guard';

export const peopleRouting: Routes = [
  {
    path: '',
    redirectTo: 'users',
    pathMatch: 'full',
  },
  {
    path: '',
    component: PeopleMainTabsComponent,
    canActivate: [RolePermissionsGuard],
    children: [
      {
        path: 'users',
        component: PeopleUsersWrapperComponent,
        canActivate: [RolePermissionsGuard],
        data: {
          privileges: ['Can view Users'],
        },
      },
      {
        path: 'teams',
        component: PeopleTeamsWrapperComponent,
        canActivate: [RolePermissionsGuard],
        data: {
          privileges: ['Can view Teams'],
        },
      },
      {
        path: 'roles',
        component: PeopleRolesWrapperComponent,
        canActivate: [RolePermissionsGuard],
        data: {
          privileges: ['Can view Roles'],
        },
      },
      {
        path: 'lenses',
        component: PeopleLensesWrapperComponent,
        canActivate: [RolePermissionsGuard],
        data: {
          privileges: ['Can view Lenses'],
        },
      },
    ],
  },
  {
    path: 'users/:id',
    component: UserDetailComponent,
  },
  {
    path: '',
    redirectTo: 'users',
    pathMatch: 'full',
  },
];
